import Button from '@mui/material/Button';
import {

    Box,
    Grid2 as Grid,
    Typography
} from '@mui/material';
import { globalstyles } from '../lib/definitions';
import { Delete, Info, LibraryAddCheck, List, MilitaryTech, Padding, PictureAsPdf, PlayArrow, Save, Stop, ViewList, Warning } from '@mui/icons-material';

import { OneCow, DynamicOneCow } from '../definitions/cow';
import {  PresenceIcon  } from '../components/PresenceButton';
import { useRef, useState } from 'react';
import { CowSublistAdvanceDialog } from '../modals/CowSublistAdvanceDialog';
import { MatchSplitDialog } from '../modals/MatchSplitDialog';
import MatchcowlistMenu from './menu/MatchCowlistMenu';
import { propComparatorDate } from '../utils/ui_utils';


export const PrematchCowlistHeader = ({ linked_cow_list, manual_cow_list, cur_match, editFn, doSplit, addCowList }) => {
    const dialogRef = useRef()
    const splitRef = useRef()

    const handleAdd = () => {
        dialogRef.current.onOpen(//cow_list, curElement)
            linked_cow_list.filter(c => c.is_present === true), cur_match
        )
    }
    const editCowList = (cl) => {
        console.log("EDIT CL", cl)
        addCowList(cl)
    }

    const undoSplit = () => {
        doSplit({ ...cur_match, cow_list: [] })
    }

    const handleSplit = () => {
        let c_list = []
        if (linked_cow_list?.length > 0) {
            c_list = [...linked_cow_list]
        }
        if (manual_cow_list?.length > 0) {
            c_list = [...c_list, ...manual_cow_list]
        }
        splitRef.current.onOpen(cur_match, c_list)
    }

    return (

        <>
            <CowSublistAdvanceDialog ref={dialogRef} addCow={editCowList} />
            <MatchSplitDialog ref={splitRef} editFn={editFn} splitFn={doSplit} />
            {cur_match.cow_list.length > 0 ?
                <Grid container sx={{
                    ...globalstyles.listHeader,
                    height: '25px'
                }}>
                    <Grid size={1}>
                        Catalogo
                    </Grid>
                    <Grid size={1}>
                        Matricola
                    </Grid>
                    <Grid size="grow">
                        Nome
                    </Grid>
                    <Grid size="grow">
                        Proprietà
                    </Grid>
                    <Grid size={1}>
                        Parti
                    </Grid>
                    <Grid size={1}>
                        Età (mesi)
                    </Grid>
                    <Grid size={1}>
                        Data di nascita
                    </Grid>
                    <Grid size={"grow"}>
                        {(cur_match.status === undefined || cur_match.status === 'pre') && <>
                            {/*                         {cur_match.cow_list &&
                            <PresenceSummary element_list={cur_match.cow_list} />
                        } */}
                            <MatchcowlistMenu handleAdd={handleAdd} handleSplit={cur_match.cow_list.length>0 && handleSplit} undoSplit={linked_cow_list?.length > 0 && cur_match.from_split && undoSplit} />
                        </>}
                    </Grid>
                </Grid>
                :
                (linked_cow_list?.length > 0 || manual_cow_list?.length > 0) &&
                <Grid container sx={{
                    ...globalstyles.listHeader,
                    height: '25px'
                }}>
                    <Grid size={1}>
                        Catalogo
                    </Grid>
                    <Grid size={1}>
                        Matricola
                    </Grid>
                    <Grid size="grow">
                        Nome
                    </Grid>
                    <Grid size="grow">
                        Proprietà
                    </Grid>
                    <Grid size={1}>
                        parti
                    </Grid>
                    <Grid size={1}>
                        Età (mesi)
                    </Grid>
                    <Grid size={1}>
                        Data di nascita
                    </Grid>
                    <Grid size={"grow"}>
                        <MatchcowlistMenu handleAdd={handleAdd} handleSplit={handleSplit} />
                    </Grid>
                </Grid>
            }
        </>
    )
}

export const PrematchCowlist = ({ linked_cow_list, dynamic_cow_list, manual_cow_list, cur_match, not_completed, handleConfirmSource, ABtn, handleShow, handleRemove }) => {

    const [selected_source_cow_id, setSelectedSourceCow] = useState([])
/*     const selectAllSource = () => {
        setSelectedSourceCow(linked_cow_list.map(c => c.id))
    }
    const selectPresence = () => {
        setSelectedSourceCow(linked_cow_list.filter(c => c.is_present === true).map(c => c.id))
    }

    const selectNoneSource = () => {
        setSelectedSourceCow([])
    } */

    const toggleSelectSource = (cow_id) => {
        console.log("TOGGLE", cow_id)
        setSelectedSourceCow(c => {
            let _c = [...c]
            const k = _c.indexOf(cow_id)
            if (k < 0) {
                _c.push(cow_id)
            } else {
                _c.splice(k, 1)
            }
            return _c
        })
    }


    const viewStatus = 'pre'

    if (cur_match.cow_list?.length > 0) {
        let l = cur_match.cow_list.filter(c => (
                        c.is_present === true
                    ))//.sort(propComparatorDate('birthdate', true, 'catalog_id'))
                    console.log("SORT LIST", l)
        if (linked_cow_list.length>0){
            l = l.sort(propComparatorDate('birthdate', true, 'catalog_id'))
        }
        return (
            <>
                <Grid sx={{ fontSize: '16px' }} size="grow" >
                    {l.map((cow, k) => (
                        <OneCow
                            cow={cow}
                            key={k}
                            index={k}
                            showSelect
                            matchStatus={viewStatus}
                            btn={
                                <>
                                    {cur_match.status === undefined || cur_match.status === 'pre' ?
                                        <>
                                            <ABtn cow={cow} index={k} />
                                        </> :
                                        <PresenceIcon is_present={cow.is_in_ring} label={'nel ring'} />
                                    }
                                    <Button size="small" variant="outlined" onClick={() => handleShow(cow)}><Info sx={{ fontSize: '1.2em' }} /></Button>
                                </>

                            }
                            //toggleSelect={handleAddCowList ? toggleSelectSource : undefined}
                            is_selected={selected_source_cow_id.indexOf(cow.id) >= 0}
                        />
                    ))}
                </Grid>
            </>
        )

    } else {


        return (
            <>
                {linked_cow_list?.length > 0 &&
                    <Grid sx={{ fontSize: '16px' }}>
                        <Grid container flexDirection={"row"}
                            sx={{ ...globalstyles.sectionHeader, backgroundColor: 'lightgrey', color: 'black', p: 0, m: 0 }}
                            spacing={1}
                        >
                            <Grid size={"grow"} sx={{ pl: 1 }} >
                                Soggetti provenienti dalla categoria collegata: <b>{cur_match.linked_category?.category_name}</b> - {cur_match.linked_category?.category_description}
                            </Grid>
                            <Grid size="auto">
                                ({linked_cow_list.filter(c => c.is_present === true).map(c => c.id).length} presenti/{linked_cow_list.length} da categoria)
                            </Grid>
                        </Grid>

                        {linked_cow_list.filter(c => (
                            c.is_present === true
                        )).map((cow, k) => (
                            <OneCow
                                cow={cow}
                                key={k}
                                index={k}
                                showSelect
                                matchStatus={viewStatus}
                                btn={
                                    <>
                                        <ABtn cow={{ ...cow, is_in_ring: cow.is_in_ring || cow.is_present }} index={k} />
                                        <Button size="small" variant="outlined" onClick={() => handleShow(cow)}><Info sx={{ fontSize: '1.2em' }} /></Button>
                                    </>

                                }
                                //toggleSelect={handleAddCowList ? toggleSelectSource : undefined}
                                is_selected={selected_source_cow_id.indexOf(cow.id) >= 0}
                            />
                        ))}
                        {linked_cow_list.filter(c => (
                            c.is_present === true
                        )).length== 0 &&<Typography sx={globalstyles.missing_value}>
                         Nessun soggetto presente alla manifestazione
                        </Typography>}
                    </Grid>
                }
                {dynamic_cow_list.length > 0 &&
                    <Grid sx={{ fontSize: '16px' }}>
                        <Grid container sx={{ ...globalstyles.sectionHeader, backgroundColor: 'lightgrey', color: 'black', p: 0, m: 0 }} spacing={1}>
                            <Grid size={"grow"} sx={{ pl: 1 }} >
                                Soggetti provenienti da {Object.keys(cur_match.source_list_data).length} gare precedenti
                            </Grid>
                            <Grid size={"auto"}>
                                {dynamic_cow_list.length} soggetti
                            </Grid>
                            {/*                             <Grid size="auto" sx={{ alignText: 'center', }}>
                                <ButtonGroup>

                                    <Button size="small" disabled={(cur_match.status !== undefined && cur_match.status !== 'pre')}
                                        onClick={handleConfirmSource} startIcon={<Save />} endIcon={not_completed > 0 && <Warning />} variant="contained" color="warning">{cur_match.cow_list?.length === 0 ? 'Conferma inserimento soggetti' : 'Aggiorna soggetti'} </Button>
                                </ButtonGroup>
                            </Grid> */}

                        </Grid>
                        <Grid container sx={globalstyles.listHeader}>
                            <Grid size={1}>
                                indice
                            </Grid>
                            <Grid size={1} sx={{ fontWeight: 'bold' }}>
                                Catalogo
                            </Grid>
                            <Grid size={3}>
                                <Grid container size="grow">
                                    <Grid size="grow">
                                        Gara disputata
                                    </Grid>
                                    <Grid size="grow">
                                        Posizione
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid size={1}>
                                Matricola
                            </Grid>
                            <Grid size={2}>
                                Proprietà
                            </Grid>
                            <Grid size={1}>
                                parti
                            </Grid>
                            <Grid size={1}>
                                Età (mesi)
                            </Grid>
                            <Grid size={1}>
                                Data di nascita
                            </Grid>
                        </Grid>
                        {dynamic_cow_list.map((cow, k) => (
                            <DynamicOneCow
                                cow={cow}
                                key={k}
                                index={k}
                                toggleSelect={toggleSelectSource}
                                is_selected={selected_source_cow_id.indexOf(cow.id) >= 0}
                            />
                        ))}
                        <Grid size={"auto"} sx={{ color: 'red', textAlign: 'center' }}>

                            {not_completed > 0 && <>
                                <Warning sx={{ fontSize: '1em' }} /> <b>Dati parziali</b> <br />{not_completed}&nbsp;
                                {not_completed === 1 ?
                                    <>
                                        gara precedente non ancora completata
                                    </>
                                    :
                                    <>
                                        gare precedenti non ancora completate
                                    </>
                                }
                            </>}
                        </Grid>
                    </Grid>
                }
                {manual_cow_list?.length > 0 &&
                    <Grid sx={{ fontSize: '16px' }}>
                        <Grid container flexDirection={"row"}
                            sx={{ ...globalstyles.sectionHeader, backgroundColor: 'lightgrey', color: 'black', p: 0, m: 0 }}
                            spacing={1}
                        >
                            <Grid size={"grow"} sx={{ pl: 1 }} >
                                Soggetti inseriti manualmente
                            </Grid>
                            <Grid size="auto">
                                ({manual_cow_list.map(c => c.id).length})
                            </Grid>
                        </Grid>

                        {manual_cow_list.map((cow, k) => (
                            <OneCow
                                cow={cow}
                                key={k}
                                index={k}
                                matchStatus={viewStatus}
                                btn={
                                    <>
                                        <ABtn cow={{ ...cow, is_in_ring: cow.is_in_ring || cow.is_present }} index={k} />
                                        <Button size="small" variant="outlined" onClick={() => handleShow(cow)}><Info sx={{ fontSize: '1.2em' }} /></Button>
                                        <Button size="small" variant="outlined" color="error" onClick={() => handleRemove(cow)}><Delete sx={{ fontSize: '1.2em' }} /></Button>
                                    </>

                                }
                                //toggleSelect={handleAddCowList ? toggleSelectSource : undefined}
                                is_selected={selected_source_cow_id.indexOf(cow.id) >= 0}
                            />
                        ))}
                    </Grid>
                }
            </>


        )
    }
}